module.exports = __webpack_public_path__ + "static/media/hjortron_223136.0c2d4a41.png";